export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5226.e65d7ed5.jpg";